const initialState = {
    //view customer
    loadingCustomerData: false,
    CustomerDataError: "",
    CustomerData: [],


    loadingCustomerContractListAdminData: false,
    CustomerContractListAdmin: "",
    CustomerContractListAdminError: '',

    loadingCustomerRegDataApi: false,
    CustomerRegDataError: "",
    CustomerRegData: [],

    loadingCustomerProfileDataApi: false,
    CustomerProfileDataError: "",
    CustomerProfileData: [],

    loadingCustomerUpdateProfileData: true,
    CustomerUpdateProfileData: {},
    CustomerUpdateProfileDataError: '',

    loadingCustomerProfileDocumentFieldsApi: false,
    CustomerProfileDocumentFieldsError: "",
    CustomerProfileDocumentFields: [],

    loadingCustomerDocumentFieldsApi: false,
    CustomerDocumentFieldsError: "",
    CustomerDocumentFields: [],

    loadingCustomerListApi: false,
    CustomerListError: "",
    CustomerList: [],
    CustomerCurrentPage: 0,
    CustomerTotalPage: 0,
    CustomerTotalData: 0,
    CustomerParentDetail: null,


    // applicable slab list
    loadingApplicableListSlabApi: false,
    ApplicableListSlabError: "",
    ApplicableListSlab: [],

    // applicable slab view
    loadingApplicableViewSlabApi: false,
    ApplicableViewSlabError: "",
    ApplicableViewSlab: [],

    // AIRLINE list
    loadingAirlineMasterListSlabApi: false,
    AirlineMasterListError: "",
    AirlineMasterList: [],

    // AIRLINE view
    loadingAirlineMasterViewSlabApi: false,
    AirlineMasterViewError: "",
    AirlineMasterView: [],

    loadingCustomerDocumentListApi: false,
    CustomerDocumentListError: "",
    CustomerDocumentList: [],

    loadingCustomerProfileDocumentListApi: false,
    CustomerProfileDocumentListError: "",
    CustomerProfileDocumentList: [],

    loadingContractInfo: false,
    ContractInfo: "",
    ContractInfoError: '',

    loadingContractInfoAdmin: false,
    ContractInfoAdmin: "",
    ContractInfoAdminError: '',

    loadingCustomerContracts: true,
    CustomerContractsError: "",
    CustomerContracts: [],

    loadingAdminDashboardCounterApi: false,
    AdminDashboardCounterError: "",
    AdminDashboardCounter: [],

    loadingAdminDashboardAllLeadsGraphApi: false,
    AdminDashboardAllLeadsGraphError: "",
    AdminDashboardAllLeadsGraph: [],

    loadingAdminDashboardTotalQueryGraphApi: false,
    AdminDashboardTotalQueryGraphError: "",
    AdminDashboardTotalQueryGraph: [],


    loadingSalesCrmDashboardCounterApi: false,
    SalesCrmDashboardCounterError: "",
    SalesCrmDashboardCounter: [],

    loadingSalesCrmDashboardAllLeadsGraphApi: false,
    SalesCrmDashboardAllLeadsGraphError: "",
    SalesCrmDashboardAllLeadsGraph: [],

    loadingSalesCrmDashboardTotalQueryGraphApi: false,
    SalesCrmDashboardTotalQueryGraphError: "",
    SalesCrmDashboardTotalQueryGraph: [],


    loadingPricingDashboardCounterApi: false,
    PricingDashboardCounterError: "",
    PricingDashboardCounter: [],

    loadingPricingDashboardAllLeadsGraphApi: false,
    PricingDashboardAllLeadsGraphError: "",
    PricingDashboardAllLeadsGraph: [],

    DashboardGraphDropdownData: [],
    DashboardSecondGraphDropdownData: [],


    //lead List 
    loadingCustomerLeadStatus: false,
    CustomerLeadStatusDataError: "",
    CustomerLeadStatusData: [],
    CustomerLeadStatusCurrentPage: 0,
    CustomerLeadStatusTotalPage: 0,
    CustomerLeadStatusTotalData: 0,

    //quote details
    loadingCustomerQuoteDetail: false,
    CustomerQuoteDetailDataError: "",
    CustomerQuoteDetailData: [],


}

const CustomerReducer = (state = initialState, action) => {
    switch (action.type) {

        //lead List//
        case 'FIND_LEAD_STATUS_REQUEST':
            return {
                ...state,
                loadingCustomerLeadStatus: true,
                CustomerLeadStatusData: [],
                CustomerLeadStatusDataError: '',
            };
        case 'FIND_LEAD_STATUS_SUCCESS':
            return {
                ...state,
                loadingCustomerLeadStatus: false,
                CustomerLeadStatusData: action.payload.data,
                CustomerLeadStatusCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                CustomerLeadStatusTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                CustomerLeadStatusTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
            };
        case 'FIND_LEAD_STATUS_FAILURE':
            return {
                ...state,
                loadingCustomerLeadStatus: false,
                CustomerLeadStatusDataError: action.payload,
            };
        //lead List//


        //quote details List//
        case 'FIND_CUSTOMER_QUOTE_DETAIL_REQUEST':
            return {
                ...state,
                loadingCustomerQuoteDetail: true,
                CustomerQuoteDetailData: {},
                CustomerQuoteDetailDataError: '',
            };
        case 'FIND_CUSTOMER_QUOTE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCustomerQuoteDetail: false,
                CustomerQuoteDetailData: action.payload,
            };
        case 'FIND_CUSTOMER_QUOTE_DETAIL_FAILURE':
            return {
                ...state,
                loadingCustomerQuoteDetail: false,
                CustomerQuoteDetailDataError: action.payload,
            };
        //quote details//

        //view customer//
        case 'FIND_CUSTOMER_DATA_REQUEST':
            return {
                ...state,
                loadingCustomerData: true,
                CustomerData: "",
                CustomerDataError: '',
            };
        case 'FIND_CUSTOMER_DATA_SUCCESS':
            return {
                ...state,
                loadingCustomerData: false,
                CustomerData: action.payload,
            };
        case 'FIND_CUSTOMER_DATA_FAILURE':
            return {
                ...state,
                loadingCustomerData: false,
                CustomerDataError: action.payload,
            };
        //view customer//

        //view customer contact list at admin//
        case 'FIND_CUSTOMER_CONTRACT_LIST_ADMIN_REQUEST':
            return {
                ...state,
                loadingCustomerContractListAdminData: true,
                CustomerContractListAdmin: "",
                CustomerContractListAdminError: '',
            };
        case 'FIND_CUSTOMER_CONTRACT_LIST_ADMIN_SUCCESS':
            return {
                ...state,
                loadingCustomerContractListAdminData: false,
                CustomerContractListAdmin: action.payload,
            };
        case 'FIND_CUSTOMER_CONTRACT_LIST_ADMIN_FAILURE':
            return {
                ...state,
                loadingCustomerContractListAdminData: false,
                CustomerContractListAdminError: action.payload,
            };
        //view customer contact list at admin//

        //employee//
        case 'FIND_CUSTOMER_REG_DATA_REQUEST':
            return {
                ...state,
                loadingCustomerRegDataApi: true,
                CustomerRegData: "",
                CustomerRegDataError: '',
            };
        case 'FIND_CUSTOMER_REG_DATA_SUCCESS':
            return {
                ...state,
                loadingCustomerRegDataApi: false,
                CustomerRegData: action.payload,
            };
        case 'FIND_CUSTOMER_REG_DATA_FAILURE':
            return {
                ...state,
                loadingCustomerRegDataApi: false,
                CustomerRegDataError: action.payload,
            };
        //employee//

        //employee//
        case 'FIND_CUSTOMER_PROFILE_DATA_REQUEST':
            return {
                ...state,
                loadingCustomerProfileDataApi: true,
                CustomerProfileData: "",
                CustomerProfileDataError: '',
            };
        case 'FIND_CUSTOMER_PROFILE_DATA_SUCCESS':
            return {
                ...state,
                loadingCustomerProfileDataApi: false,
                CustomerProfileData: action.payload,
            };
        case 'FIND_CUSTOMER_PROFILE_DATA_FAILURE':
            return {
                ...state,
                loadingCustomerProfileDataApi: false,
                CustomerProfileDataError: action.payload,
            };
        //employee//

        //employee//
        case 'FIND_CUSTOMER_UPDATE_PROFILE_DATA_REQUEST':
            return {
                ...state,
                loadingCustomerUpdateProfileData: true,
                CustomerUpdateProfileData: "",
                CustomerUpdateProfileDataError: '',
            };
        case 'FIND_CUSTOMER_UPDATE_PROFILE_DATA_SUCCESS':
            return {
                ...state,
                loadingCustomerUpdateProfileData: false,
                CustomerUpdateProfileData: action.payload,
            };
        case 'FIND_CUSTOMER_UPDATE_PROFILE_DATA_FAILURE':
            return {
                ...state,
                loadingCustomerUpdateProfileData: false,
                CustomerUpdateProfileDataError: action.payload,
            };
        //employee//

        //employee//
        case 'FIND_CUSTOMER_PROFILE_DOCUMENT_FIELDS_REQUEST':
            return {
                ...state,
                loadingCustomerProfileDocumentFieldsApi: true,
                CustomerProfileDocumentFields: "",
                CustomerProfileDocumentFieldsError: '',
            };
        case 'FIND_CUSTOMER_PROFILE_DOCUMENT_FIELDS_SUCCESS':
            return {
                ...state,
                loadingCustomerProfileDocumentFieldsApi: false,
                CustomerProfileDocumentFields: action.payload,
            };
        case 'FIND_CUSTOMER_PROFILE_DOCUMENT_FIELDS_FAILURE':
            return {
                ...state,
                loadingCustomerProfileDocumentFieldsApi: false,
                CustomerProfileDocumentFieldsError: action.payload,
            };
        //employee//


        //employee//
        case 'FIND_CUSTOMER_DOCUMENT_FIELDS_REQUEST':
            return {
                ...state,
                loadingCustomerDocumentFieldsApi: true,
                CustomerDocumentFields: "",
                CustomerDocumentFieldsError: '',
            };
        case 'FIND_CUSTOMER_DOCUMENT_FIELDS_SUCCESS':
            return {
                ...state,
                loadingCustomerDocumentFieldsApi: false,
                CustomerDocumentFields: action.payload,
            };
        case 'FIND_CUSTOMER_DOCUMENT_FIELDS_FAILURE':
            return {
                ...state,
                loadingCustomerDocumentFieldsApi: false,
                CustomerDocumentFieldsError: action.payload,
            };
        //employee//

        //customer list//
        case 'FIND_CUSTOMER_LIST_REQUEST':
            return {
                ...state,
                loadingCustomerListApi: true,
                CustomerList: "",
                CustomerListError: '',
            };
        case 'FIND_CUSTOMER_LIST_SUCCESS':
            return {
                ...state,
                loadingCustomerListApi: false,
                CustomerList: action.payload?.data,
                CustomerParentDetail: action.payload?.parent_agent_detail,
                CustomerCurrentPage: action?.payload?.pagination?.currentPage,
                CustomerTotalPage: action?.payload?.pagination?.totalPages,
                CustomerTotalData: action?.payload?.pagination?.totalRecords,

            };
        case 'FIND_CUSTOMER_LIST_FAILURE':
            return {
                ...state,
                loadingCustomerListApi: false,
                CustomerListError: action?.payload,
            };
        //customer list//


        //applicable slab list//
        case 'FIND_APPLICABLE_SLAB_LIST_REQUEST':
            return {
                ...state,
                loadingApplicableListSlabApi: true,
                ApplicableListSlab: "",
                ApplicableListSlabError: '',
            };
        case 'FIND_APPLICABLE_SLAB_LIST_SUCCESS':
            return {
                ...state,
                loadingApplicableListSlabApi: false,
                ApplicableListSlab: action.payload,
            };
        case 'FIND_APPLICABLE_SLAB_LIST_FAILURE':
            return {
                ...state,
                loadingApplicableListSlabApi: false,
                ApplicableListSlabError: action.payload,
            };
        //applicable slab list//


        //applicable slab view//
        case 'FIND_APPLICABLE_SLAB_VIEW_REQUEST':
            return {
                ...state,
                loadingApplicableViewSlabApi: true,
                ApplicableViewSlab: "",
                ApplicableViewSlabError: '',
            };
        case 'FIND_APPLICABLE_SLAB_VIEW_SUCCESS':
            return {
                ...state,
                loadingApplicableViewSlabApi: false,
                ApplicableViewSlab: action.payload,
            };
        case 'FIND_APPLICABLE_SLAB_VIEW_FAILURE':
            return {
                ...state,
                loadingApplicableViewSlabApi: false,
                ApplicableViewSlabError: action.payload,
            };
        //applicable slab view//


        //airline list//
        case 'FIND_AIRLINE_MASTER_LIST_REQUEST':
            return {
                ...state,
                loadingAirlineMasterListSlabApi: true,
                AirlineMasterList: "",
                AirlineMasterListError: '',
            };
        case 'FIND_AIRLINE_MASTER_LIST_SUCCESS':
            return {
                ...state,
                loadingAirlineMasterListSlabApi: false,
                AirlineMasterList: action.payload,
            };
        case 'FIND_AIRLINE_MASTER_LIST_FAILURE':
            return {
                ...state,
                loadingAirlineMasterListSlabApi: false,
                AirlineMasterListError: action.payload,
            };
        //airline list//


        //airline view//
        case 'FIND_AIRLINE_MASTER_VIEW_REQUEST':
            return {
                ...state,
                loadingAirlineMasterViewSlabApi: true,
                AirlineMasterView: "",
                AirlineMasterViewError: '',
            };
        case 'FIND_AIRLINE_MASTER_VIEW_SUCCESS':
            return {
                ...state,
                loadingAirlineMasterViewSlabApi: false,
                AirlineMasterView: action.payload,
            };
        case 'FIND_AIRLINE_MASTER_VIEW_FAILURE':
            return {
                ...state,
                loadingAirlineMasterViewSlabApi: false,
                AirlineMasterViewError: action.payload,
            };
        //airline view//


        //document list//
        case 'FIND_CUSTOMER_DOCUMENT_LIST_REQUEST':
            return {
                ...state,
                loadingCustomerDocumentListApi: true,
                CustomerDocumentList: "",
                CustomerDocumentListError: '',
            };
        case 'FIND_CUSTOMER_DOCUMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingCustomerDocumentListApi: false,
                CustomerDocumentList: action.payload,
            };
        case 'FIND_CUSTOMER_DOCUMENT_LIST_FAILURE':
            return {
                ...state,
                loadingCustomerDocumentListApi: false,
                CustomerDocumentListError: action.payload,
            };
        //document list//

        //customer profile document list//
        case 'FIND_CUSTOMER_PROFILE_DOCUMENT_LIST_REQUEST':
            return {
                ...state,
                loadingCustomerProfileDocumentListApi: true,
                CustomerProfileDocumentList: "",
                CustomerProfileDocumentListError: '',
            };
        case 'FIND_CUSTOMER_PROFILE_DOCUMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingCustomerProfileDocumentListApi: false,
                CustomerProfileDocumentList: action.payload,
            };
        case 'FIND_CUSTOMER_PROFILE_DOCUMENT_LIST_FAILURE':
            return {
                ...state,
                loadingCustomerProfileDocumentListApi: false,
                CustomerProfileDocumentListError: action.payload,
            };
        //document list//

        //Contarct info//
        case 'FIND_CONTRACT_INFO_REQUEST':
            return {
                ...state,
                loadingContractInfo: true,
                ContractInfo: "",
                ContractInfoError: '',
            };
        case 'FIND_CONTRACT_INFO_SUCCESS':
            return {
                ...state,
                loadingContractInfo: false,
                ContractInfo: action.payload,
            };
        case 'FIND_CONTRACT_INFO_FAILURE':
            return {
                ...state,
                loadingContractInfo: false,
                ContractInfoError: action.payload,
            };
        //contract info//

        //Contarct info admin//
        case 'FIND_CONTRACT_INFO_ADMIN_REQUEST':
            return {
                ...state,
                loadingContractInfoAdmin: true,
                ContractInfoAdmin: "",
                ContractInfoAdminError: '',
            };
        case 'FIND_CONTRACT_INFO_ADMIN_SUCCESS':
            return {
                ...state,
                loadingContractInfoAdmin: false,
                ContractInfoAdmin: action.payload,
            };
        case 'FIND_CONTRACT_INFO_ADMIN_FAILURE':
            return {
                ...state,
                loadingContractInfoAdmin: false,
                ContractInfoAdminError: action.payload,
            };
        //contract info admin//


        //customer contracts list//
        case 'FIND_CUSTOMER_CONTRACTS_REQUEST':
            return {
                ...state,
                loadingCustomerContracts: true,
                CustomerContracts: "",
                CustomerContractsError: '',
            };
        case 'FIND_CUSTOMER_CONTRACTS_SUCCESS':
            return {
                ...state,
                loadingCustomerContracts: false,
                CustomerContracts: action.payload,
            };
        case 'FIND_CUSTOMER_CONTRACTS_FAILURE':
            return {
                ...state,
                loadingCustomerContracts: false,
                CustomerContractsError: action.payload,
            };
        //customer contracts list//


        //admin dashboard counter list//
        case 'FIND_ADMIN_DASHBOARD_COUNTER_REQUEST':
            return {
                ...state,
                loadingAdminDashboardCounterApi: true,
                AdminDashboardCounter: "",
                AdminDashboardCounterError: '',
            };
        case 'FIND_ADMIN_DASHBOARD_COUNTER_SUCCESS':
            return {
                ...state,
                loadingAdminDashboardCounterApi: false,
                AdminDashboardCounter: action.payload,
            };
        case 'FIND_ADMIN_DASHBOARD_COUNTER_FAILURE':
            return {
                ...state,
                loadingAdminDashboardCounterApi: false,
                AdminDashboardCounterError: action.payload,
            };
        //admin dashboard counter list//


        //admin dashboard counter list//
        case 'FIND_ADMIN_DASHBOARD_ALL_LEAD_GRAPHS_REQUEST':
            return {
                ...state,
                loadingAdminDashboardAllLeadsGraphApi: true,
                AdminDashboardAllLeadsGraph: "",
                AdminDashboardAllLeadsGraphError: '',
            };
        case 'FIND_ADMIN_DASHBOARD_ALL_LEAD_GRAPHS_SUCCESS':
            return {
                ...state,
                loadingAdminDashboardAllLeadsGraphApi: false,
                AdminDashboardAllLeadsGraph: action.payload,
            };
        case 'FIND_ADMIN_DASHBOARD_ALL_LEAD_GRAPHS_FAILURE':
            return {
                ...state,
                loadingAdminDashboardAllLeadsGraphApi: false,
                AdminDashboardAllLeadsGraphError: action.payload,
            };
        //admin dashboard counter list//


        //admin dashboard counter list//
        case 'FIND_ADMIN_DASHBOARD_TOTAL_QUERY_GRAPHS_REQUEST':
            return {
                ...state,
                loadingAdminDashboardTotalQueryGraphApi: true,
                AdminDashboardTotalQueryGraph: "",
                AdminDashboardTotalQueryGraphError: '',
            };
        case 'FIND_ADMIN_DASHBOARD_TOTAL_QUERY_GRAPHS_SUCCESS':
            return {
                ...state,
                loadingAdminDashboardTotalQueryGraphApi: false,
                AdminDashboardTotalQueryGraph: action.payload,
            };
        case 'FIND_ADMIN_DASHBOARD_TOTAL_QUERY_GRAPHS_FAILURE':
            return {
                ...state,
                loadingAdminDashboardTotalQueryGraphApi: false,
                AdminDashboardTotalQueryGraphError: action.payload,
            };
        //admin dashboard counter list//


        //sales crm dashboard counter list//
        case 'FIND_SALES_CRM_DASHBOARD_COUNTER_REQUEST':
            return {
                ...state,
                loadingSalesCrmDashboardCounterApi: true,
                SalesCrmDashboardCounter: "",
                SalesCrmDashboardCounterError: '',
            };
        case 'FIND_SALES_CRM_DASHBOARD_COUNTER_SUCCESS':
            return {
                ...state,
                loadingSalesCrmDashboardCounterApi: false,
                SalesCrmDashboardCounter: action.payload,
            };
        case 'FIND_SALES_CRM_DASHBOARD_COUNTER_FAILURE':
            return {
                ...state,
                loadingSalesCrmDashboardCounterApi: false,
                SalesCrmDashboardCounterError: action.payload,
            };
        //sales crm dashboard counter list//


        //sales crm dashboard all lead graph list//
        case 'FIND_SALES_CRM_DASHBOARD_ALL_LEAD_GRAPHS_REQUEST':
            return {
                ...state,
                loadingSalesCrmDashboardAllLeadsGraphApi: true,
                SalesCrmDashboardAllLeadsGraph: "",
                SalesCrmDashboardAllLeadsGraphError: '',
            };
        case 'FIND_SALES_CRM_DASHBOARD_ALL_LEAD_GRAPHS_SUCCESS':
            return {
                ...state,
                loadingSalesCrmDashboardAllLeadsGraphApi: false,
                SalesCrmDashboardAllLeadsGraph: action.payload,
            };
        case 'FIND_SALES_CRM_DASHBOARD_ALL_LEAD_GRAPHS_FAILURE':
            return {
                ...state,
                loadingSalesCrmDashboardAllLeadsGraphApi: false,
                SalesCrmDashboardAllLeadsGraphError: action.payload,
            };
        //sales crm dashboard all lead graph list//


        //sales crm dashboard total query graph list//
        case 'FIND_SALES_CRM_DASHBOARD_TOTAL_QUERY_GRAPHS_REQUEST':
            return {
                ...state,
                loadingSalesCrmDashboardTotalQueryGraphApi: true,
                SalesCrmDashboardTotalQueryGraph: "",
                SalesCrmDashboardTotalQueryGraphError: '',
            };
        case 'FIND_SALES_CRM_DASHBOARD_TOTAL_QUERY_GRAPHS_SUCCESS':
            return {
                ...state,
                loadingSalesCrmDashboardTotalQueryGraphApi: false,
                SalesCrmDashboardTotalQueryGraph: action.payload,
            };
        case 'FIND_SALES_CRM_DASHBOARD_TOTAL_QUERY_GRAPHS_FAILURE':
            return {
                ...state,
                loadingSalesCrmDashboardTotalQueryGraphApi: false,
                SalesCrmDashboardTotalQueryGraphError: action.payload,
            };
        //sales crm dashboard total query graph list//

        //pricing dashboard counter list//
        case 'FIND_PRICING_DASHBOARD_COUNTER_REQUEST':
            return {
                ...state,
                loadingPricingDashboardCounterApi: true,
                PricingDashboardCounter: "",
                PricingDashboardCounterError: '',
            };
        case 'FIND_PRICING_DASHBOARD_COUNTER_SUCCESS':
            return {
                ...state,
                loadingPricingDashboardCounterApi: false,
                PricingDashboardCounter: action.payload,
            };
        case 'FIND_PRICING_DASHBOARD_COUNTER_FAILURE':
            return {
                ...state,
                loadingPricingDashboardCounterApi: false,
                PricingDashboardCounterError: action.payload,
            };
        //pricing dashboard counter list//


        //pricing dashboard all lead graph list//
        case 'FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_REQUEST':
            return {
                ...state,
                loadingPricingDashboardAllLeadsGraphApi: true,
                PricingDashboardAllLeadsGraph: "",
                PricingDashboardAllLeadsGraphError: '',
            };
        case 'FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_SUCCESS':
            return {
                ...state,
                loadingPricingDashboardAllLeadsGraphApi: false,
                PricingDashboardAllLeadsGraph: action.payload,
            };
        case 'FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_FAILURE':
            return {
                ...state,
                loadingPricingDashboardAllLeadsGraphApi: false,
                PricingDashboardAllLeadsGraphError: action.payload,
            };
        //pricing dashboard all lead graph list//
        case 'FIND_DASHBOARD_DROPDOWN':
            return {
                ...state,
                DashboardGraphDropdownData: action.payload,
            };
        case 'FIND_DASHBOARD_SECOND_DROPDOWN':
            return {
                ...state,
                DashboardSecondGraphDropdownData: action.payload,
            };


        //customer quotation list//
        case 'FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_REQUEST':
            return {
                ...state,
                loadingPricingDashboardAllLeadsGraphApi: true,
                PricingDashboardAllLeadsGraph: "",
                PricingDashboardAllLeadsGraphError: '',
            };
        case 'FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_SUCCESS':
            return {
                ...state,
                loadingPricingDashboardAllLeadsGraphApi: false,
                PricingDashboardAllLeadsGraph: action.payload,
            };
        case 'FIND_PRICING_DASHBOARD_ALL_LEAD_GRAPHS_FAILURE':
            return {
                ...state,
                loadingPricingDashboardAllLeadsGraphApi: false,
                PricingDashboardAllLeadsGraphError: action.payload,
            };
        //customer quotation list//

        default:
            return state;
    }
}

export default CustomerReducer;